var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticStyle: { display: "none" } }, [
    _c("div", { staticClass: "ui action left icon input" }, [
      _c("i", { staticClass: "search icon" }),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.query,
            expression: "query"
          }
        ],
        attrs: { placeholder: "Search...", type: "text" },
        domProps: { value: _vm.query },
        on: {
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.query = $event.target.value
          }
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "ui teal button", on: { click: _vm.addWorld } },
        [_vm._v("Search")]
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "ui list" },
      _vm._l(_vm.words, function(word, index) {
        return _c("div", { key: index, staticClass: "item" }, [
          _c("div", { staticClass: "ui tag teal label" }, [
            _vm._v("\n        " + _vm._s(word) + "\n        "),
            _c("i", {
              staticClass: "delete icon",
              on: {
                click: function($event) {
                  return _vm.deleteWord($event)
                }
              }
            })
          ])
        ])
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }